import React from "react";

export default function Header() {
  return (
    <div className="py-4">
      <p className="text-black text-xl text-center"> Github Repo Comparision</p>
      <p className="text-gray-500 text-sm text-center">
        Take your favorite repositories head-to-head! 
      </p>
    </div>
  );
}
